<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u4IMKT/tc-custom/9781473879652.jpg?1728725526140" alt="This image is the cover for the book Edinburgh at War, 1939–45, Your Towns & Cities in World War Two"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Edinburgh at War, 1939–45, Your Towns & Cities in World War Two
      </h1>
      <p class="bookDescription body article font2">
        <p>Scotland was of grave strategic importance during the war because of its geographical position and its capital was the location of a significant number of important military and civil organizations. Edinburgh Castle became the HQ of the Scottish Home Forces whilst the Forth was a vitally important port and was heavily protected even before the start of the war. Its importance was marked by its attracting the first air raid of the war on mainland Britain when a force of German bombers was sent to attack naval shipping in the Forth on 16th October 1939. The raid was intercepted by the RAF which shot down at least two bombers and the entire action was witnessed by many civilians on the ground. The raid also caused the first civilian casualties when two women were injured in Edinburgh and two men machine-gunned in Portobello. Thousands lined the streets days later for the funeral of two of the Luftwaffe airmen.No member of the population of Edinburgh escaped the war, whether it was the huge numbers of men and women from the area who came forward for service in the military or in roles such as the Home Guard, ARP services, nursing, working in vital war industries, struggling to maintain a household under strict rationing and the stresses of wartime life, or children evacuated from the city to the rural areas of Scotland to escape the expected bombing campaign (even though the Archbishop of Edinburgh called for their return if there was insufficient provision of religious instruction in reception areas).Edinburgh was also home to a sizable Italian community which was badly affected by internment and the subsequent tight restrictions on movement and civil rights. The Italian community was also subjected to violent attacks when rioting mobs attacked Italian owned business throughout the city (although one family business was spared because one of the sons was known as a fanatical supporter of Hibs).Edinburgh at War 1939-1945 poignantly commemorates the efforts and achievements of Edinburgh: workers, fighters, families divided, all surviving astounding tests.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Armstrong
      </h2>
      
      <p class="authorDescription body article">Born and bred in Northumberland, Dr. Craig Armstrong is an experienced historian with a special interest in the history of the North East of England and the Anglo-Scottish Borders. He has expertise in nineteenth and twentieth century history with a particular focus on social and military history.  Dr. Armstrong currently splits his time between teaching at Newcastle University and working as a freelance researcher and writer on the history of North East England and Scotland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50e28125